import axios, { AxiosError, AxiosResponse } from 'axios';
import { UserToken } from '../authSlice';

interface HwbAuthResponseData {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  scope: string;
  token_type: 'bearer';
}

interface getNewTokenParams {
  code?: string,
  refresh_token?: string
}

interface HwbAuthResponseError {
  error: {
    name: string;
    code: number;
    stack: string;
  };
  message: string;
}

const getHwbAuthToken = async (endpoint: string, endpointParams: getNewTokenParams): Promise<UserToken | void> => {
  const response: AxiosResponse<HwbAuthResponseData> | void = await axios
    .get(`${endpoint}hwbauth/token`, {
      params: {
        ...endpointParams
      }
    })
    .catch((error: AxiosError<HwbAuthResponseError>) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
    });

  if (!response) return;

  const { data } = response;
  return {
    token: data.access_token,
    expires: Date.now() + data.expires_in * 1000,
    refreshToken: data.refresh_token,
    service: "hwb",
    userGroup: "teacher"
  };
}

export const fetchTokenWithCode = async (
  code: string
): Promise<UserToken | void> => {
  const endpoint = process.env.REACT_APP_RESOURCES_API_URL;
  if (!endpoint)
    throw Error(
      'REACT_APP_RESOURCES_API_URL environment variables is not set.'
    );

  const endpointParams: getNewTokenParams = {
    code
  }

  return getHwbAuthToken(endpoint, endpointParams);
};

export const fetchTokenWithRefreshToken = async (
  refresh_token: string
): Promise<UserToken | void> => {
  const endpoint = process.env.REACT_APP_RESOURCES_API_URL;
  if (!endpoint)
    throw Error(
      'REACT_APP_RESOURCES_API_URL environment variables is not set.'
    );

  const endpointParams: getNewTokenParams = {
    refresh_token
  }

  return getHwbAuthToken(endpoint, endpointParams);
};
